(function(){document.querySelectorAll('.vc-slideshow').forEach(function(s){var slides=[].slice.call(s.querySelectorAll('.vc-slide'));var dots=[].slice.call(s.querySelectorAll('.vc-dot'));if(slides.length<2)return;var i=0,t=null,speed=parseInt(s.getAttribute('data-speed')||'5000',10);function go(n){i=(n+slides.length)%slides.length;slides.forEach(function(el,x){el.classList.toggle('is-active',x===i);});dots.forEach(function(el,x){el.classList.toggle('is-active',x===i);});}function play(){if(s.getAttribute('data-autoplay')==='true'){stop();t=setInterval(function(){go(i+1);},speed);}}function stop(){if(t)clearInterval(t);}var nx=s.querySelector('.vc-nav.next'),pv=s.querySelector('.vc-nav.prev');if(nx)nx.addEventListener('click',function(e){e.preventDefault();go(i+1);play();});if(pv)pv.addEventListener('click',function(e){e.preventDefault();go(i-1);play();});dots.forEach(function(d,x){d.addEventListener('click',function(e){e.preventDefault();go(x);play();});});s.addEventListener('mouseenter',stop);s.addEventListener('mouseleave',play);play();});})();
(function(){document.querySelectorAll('.topbar[data-rotate="true"]').forEach(function(b){var msgs=[].slice.call(b.querySelectorAll('.topbar-msg'));if(msgs.length<2)return;var i=0,speed=parseInt(b.getAttribute('data-speed')||'4000',10);setInterval(function(){i=(i+1)%msgs.length;msgs.forEach(function(m,x){m.classList.toggle('is-active',x===i);});},speed);});})();
(function(){
  var THRESHOLD=15000;
  var drawer=document.getElementById('vcDrawer');
  if(!drawer)return;
  function money(c){return 'RM'+(c/100).toFixed(2);}
  var VC_CANDS=['not-your-makcik-s-rendang','not-your-mama-s-sambal','not-your-typical-trio','the-spicy-trio','the-fantastic-5-bundle'];
  var vcCandCache=null;
  function loadCands(){
    if(vcCandCache)return Promise.resolve(vcCandCache);
    return Promise.all(VC_CANDS.map(function(h){
      return fetch('/products/'+h+'.js').then(function(r){return r.ok?r.json():null;}).catch(function(){return null;});
    })).then(function(arr){
      vcCandCache=arr.filter(Boolean).map(function(p){return {title:p.title,url:p.url,price:p.price,img:(p.featured_image||(p.images&&p.images[0])||''),id:p.id,vid:(p.variants&&p.variants[0]&&p.variants[0].id)};});
      return vcCandCache;
    });
  }
  function openD(){drawer.classList.add('open');document.body.style.overflow='hidden';}
  function closeD(){drawer.classList.remove('open');document.body.style.overflow='';}
  function count(n){document.querySelectorAll('.cart-count').forEach(function(s){s.textContent=n;});}
  var itemsEl=drawer.querySelector('#vcDrawerItems');
  var shipEl=drawer.querySelector('#vcShip');
  var recsEl=drawer.querySelector('#vcRecs');
  var footEl=drawer.querySelector('#vcDrawerFoot');
  var titleEl=drawer.querySelector('#vcDrawerTitle');
  function bindClose(){drawer.querySelectorAll('[data-drawer-close]').forEach(function(b){b.onclick=closeD;});}
  function render(cart,title){
    count(cart.item_count);
    if(!cart.items.length){
      if(titleEl)titleEl.textContent='Your cart';
      itemsEl.innerHTML='<div class="vc-empty"><p class="muted">Your cart is empty.</p><a href="/collections/products" class="btn btn-accent btn-block" data-drawer-close>Start shopping</a></div>';
      shipEl.innerHTML='';shipEl.style.display='none';recsEl.innerHTML='';if(footEl)footEl.style.display='none';bindClose();return;
    }
    if(titleEl)titleEl.textContent=title||'Your cart';
    if(footEl)footEl.style.display='';
    shipEl.style.display='';
    itemsEl.innerHTML=cart.items.map(function(it){
      var vt=(it.variant_title&&it.variant_title.indexOf('Default')<0)?it.variant_title:'';
      var isGift=window.VC_GIFT&&it.variant_id===window.VC_GIFT.VARIANT_ID;
      var qtyHtml=isGift
        ? '<div class="vc-ci-qty vc-ci-qty--gift"><span class="vc-gift-tag">🎁 Free gift</span><button type="button" class="vc-rm" data-act="rm">No thanks, remove</button></div>'
        : '<div class="vc-ci-qty"><button type="button" class="vc-q" data-act="dec" aria-label="Decrease">&minus;</button><span>'+it.quantity+'</span><button type="button" class="vc-q" data-act="inc" aria-label="Increase">+</button><button type="button" class="vc-rm" data-act="rm">Remove</button></div>';
      return '<div class="vc-ci'+(isGift?' vc-ci--gift':'')+'" data-key="'+it.key+'"><a class="vc-ci-img" href="'+it.url+'"><img src="'+(it.image||'')+'" alt="'+it.product_title+'"></a><div class="vc-ci-b"><a class="vc-ci-t" href="'+it.url+'">'+it.product_title+'</a>'+(vt?'<div class="vc-ci-m">'+vt+'</div>':'')+qtyHtml+'</div><div class="vc-ci-p">'+(isGift?'FREE':money(it.final_line_price))+'</div></div>';
    }).join('');
    var rem=THRESHOLD-cart.total_price;
    var pct=Math.min(100,Math.round(cart.total_price/THRESHOLD*100));
    shipEl.innerHTML=(rem>0?'<div class="vc-ship-t">You are <b>'+money(rem)+'</b> away from free West Malaysia shipping</div>':'<div class="vc-ship-t">Free West Malaysia shipping unlocked!</div>')+'<div class="vc-ship-track"><span style="width:'+pct+'%"></span></div><div class="vc-ship-note">Other regions &amp; international calculated at checkout</div>';
    drawer.querySelector('#vcSubtotal').textContent=money(cart.total_price);
    recsEl.innerHTML='';
    var inCart={};
    cart.items.forEach(function(it){inCart[it.product_id]=true;});
    loadCands().then(function(cands){
      var avail=cands.filter(function(c){return !inCart[c.id];});
      var pick;
      if(rem>0){
        var over=avail.filter(function(c){return c.price>=rem;}).sort(function(a,b){return a.price-b.price;});
        var under=avail.filter(function(c){return c.price<rem;}).sort(function(a,b){return b.price-a.price;});
        pick=over.concat(under).slice(0,2);
      }else{
        pick=avail.slice(0,2);
      }
      if(!pick.length){recsEl.innerHTML='';return;}
      var head=rem>0?'Add one to unlock free shipping':'You might also like';
      recsEl.innerHTML='<div class="vc-rec-h">'+head+'</div><div class="vc-rec-row">'+pick.map(function(p){
        var im=(p.img&&p.img.indexOf('//')===0)?('https:'+p.img):p.img;
        return '<button type="button" class="vc-rec" data-vid="'+p.vid+'"><img src="'+im+'" alt=""><span>'+p.title+'</span><b>'+money(p.price)+'</b></button>';
      }).join('')+'</div>';
    }).catch(function(){});
    if(window.VC_GIFT){
      window.VC_GIFT.syncGift(cart).then(function(changed){
        if(changed)refresh(title);
      });
    }
  }
  function refresh(title){fetch('/cart.js').then(function(r){return r.json();}).then(function(c){render(c,title);});}
  itemsEl.addEventListener('click',function(e){
    var b=e.target.closest('[data-act]');
    if(!b)return;
    var row=b.closest('.vc-ci');
    if(!row)return;
    var key=row.getAttribute('data-key');
    var act=b.getAttribute('data-act');
    var span=row.querySelector('.vc-ci-qty span:not(.vc-gift-tag)');
    var q=parseInt(span?span.textContent:'1',10)||1;
    var nq=act==='rm'?0:(act==='inc'?q+1:Math.max(0,q-1));
    b.disabled=true;
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:nq})}).then(function(r){return r.json();}).then(function(c){render(c,titleEl?titleEl.textContent:'');}).catch(function(){});
  });
  recsEl.addEventListener('click',function(e){
    var b=e.target.closest('.vc-rec[data-vid]');
    if(!b||b.disabled)return;
    e.preventDefault();
    b.disabled=true;b.classList.add('is-adding');
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:parseInt(b.getAttribute('data-vid'),10),quantity:1})}).then(function(r){return r.json();}).then(function(){refresh('Added to cart');}).catch(function(){b.disabled=false;b.classList.remove('is-adding');});
  });
  var form=document.getElementById('vcAddForm');
  if(form){
    form.addEventListener('submit',function(e){
      e.preventDefault();
      var btn=form.querySelector('[type=submit]');
      var label=btn?btn.textContent:'';
      if(btn){btn.disabled=true;btn.textContent='Adding...';}
      fetch('/cart/add.js',{method:'POST',body:new FormData(form)}).then(function(r){return r.json();}).then(function(){return fetch('/cart.js');}).then(function(r){return r.json();}).then(function(cart){render(cart,'Added to cart');openD();bindClose();}).catch(function(){form.submit();}).then(function(){if(btn){btn.disabled=false;btn.textContent=label;}});
    });
  }
  document.addEventListener('click',function(e){
    var qa=e.target.closest('.vc-quick-add');
    if(!qa)return;
    e.preventDefault();
    var vid=qa.getAttribute('data-vid');
    if(!vid)return;
    qa.disabled=true;
    var lbl=qa.textContent;qa.textContent='Adding...';
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:vid,quantity:1})}).then(function(r){return r.json();}).then(function(){return fetch('/cart.js');}).then(function(r){return r.json();}).then(function(cart){render(cart,'Added to cart');openD();bindClose();}).catch(function(){}).then(function(){qa.disabled=false;qa.textContent=lbl;});
  });
  document.querySelectorAll('.nav-icon[aria-label="Cart"]').forEach(function(a){
    a.addEventListener('click',function(e){e.preventDefault();refresh('Your cart');openD();});
  });
  bindClose();
  document.addEventListener('DOMContentLoaded',function(){
    fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
      if(!window.VC_GIFT){count(cart.item_count);return;}
      window.VC_GIFT.syncGift(cart).then(function(changed){
        if(changed){
          if(document.body.classList.contains('template-cart')){location.reload();}
          else{refresh();}
        }else{
          count(cart.item_count);
        }
      });
    }).catch(function(){});
  });
})();
(function(){
  function maskName(full){
    if(!full)return full;
    return full.split(' ').filter(Boolean).map(function(w){
      if(w.length<=2)return w.charAt(0)+'*';
      if(w.length===3)return w.charAt(0)+'**';
      return w.charAt(0)+'***'+w.slice(-2);
    }).join(' ');
  }
  function maskAll(){
    document.querySelectorAll('.jdgm-rev__author, .jdgm-reviewer-name').forEach(function(el){
      if(el.getAttribute('data-vc-masked'))return;
      var t=el.textContent.trim();
      if(!t)return;
      el.textContent=maskName(t);
      el.setAttribute('data-vc-masked','1');
    });
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',maskAll);}else{maskAll();}
  var vcRevObs=new MutationObserver(function(){maskAll();});
  vcRevObs.observe(document.body,{childList:true,subtree:true});
})();
